import { render } from "./LabdaqInvalidOrders.vue?vue&type=template&id=4f227ac9"
import script from "./LabdaqInvalidOrders.vue?vue&type=script&lang=js"
export * from "./LabdaqInvalidOrders.vue?vue&type=script&lang=js"

import "./LabdaqInvalidOrders.vue?vue&type=style&index=0&id=4f227ac9&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/LabdaqInvalidOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f227ac9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f227ac9', __exports__)) {
    console.log('reload')
    api.reload('4f227ac9', __exports__)
  }
  
  module.hot.accept("./LabdaqInvalidOrders.vue?vue&type=template&id=4f227ac9", () => {
    console.log('re-render')
    api.rerender('4f227ac9', render)
  })

}


export default __exports__